module.exports = __webpack_public_path__ + "img/platform.1e20e4d9.png";